import { useId } from 'react'
import IconContainer from '@/components/IconContainer'

export default function IconColorSetting(props) {
  const id = useId()
  return (
    <IconContainer
      {...props}
      width="20"
      height="20"
      ariaLabel="Setting Icon"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        fill={`url(#${id})`}
        d="M12.1251 1.20403C11.1632 -0.40134 8.83685 -0.401344 7.87486 1.20403L7.29202 2.17666C7.10501 2.48874 6.7358 2.64167 6.3829 2.55323L5.28301 2.2776C3.46761 1.82267 1.82267 3.46761 2.2776 5.28301L2.55323 6.38289C2.64167 6.7358 2.48874 7.10501 2.17666 7.29202L1.20403 7.87486C-0.40134 8.83685 -0.401344 11.1632 1.20403 12.1251L2.17666 12.708C2.48874 12.895 2.64167 13.2642 2.55323 13.6171L2.2776 14.717C1.82267 16.5324 3.46761 18.1773 5.28301 17.7224L6.38289 17.4468C6.7358 17.3583 7.10501 17.5113 7.29202 17.8233L7.87486 18.796C8.83685 20.4013 11.1632 20.4013 12.1251 18.796L12.708 17.8233C12.895 17.5113 13.2642 17.3583 13.6171 17.4468L14.717 17.7224C16.5324 18.1773 18.1773 16.5324 17.7224 14.717L17.4468 13.6171C17.3583 13.2642 17.5113 12.895 17.8233 12.708L18.796 12.1251C20.4013 11.1632 20.4013 8.83685 18.796 7.87486L17.8233 7.29202C17.5113 7.10501 17.3583 6.7358 17.4468 6.3829L17.7224 5.28301C18.1773 3.46761 16.5324 1.82267 14.717 2.2776L13.6171 2.55323C13.2642 2.64167 12.895 2.48874 12.708 2.17666L12.1251 1.20403ZM7.52337 9.99998C7.52337 8.6317 8.63258 7.52249 10.0009 7.52249C11.3691 7.52249 12.4783 8.6317 12.4783 9.99998C12.4783 11.3683 11.3691 12.4775 10.0009 12.4775C8.63258 12.4775 7.52337 11.3683 7.52337 9.99998Z"
      />
      <defs>
        <linearGradient
          id={id}
          x1="20"
          y1="11.6071"
          x2="2.48511e-05"
          y2="11.6292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B6AFF" />
          <stop offset="1" stopColor="#39D0D8" />
        </linearGradient>
      </defs>
    </IconContainer>
  )
}
